import {useEffect, useState} from "react";
import useFetch from "use-http";

const useSettingsApi = () => {
    const [settings, setSettings] = useState(null)
    const {get, response, loading, error} = useFetch(`${process.env.REACT_APP_API_PATH}`)

    useEffect(() => {
        (async function (){
            const fetchedData = await get('/sl/v1/param');
            if(response.ok) {
                setSettings(fetchedData);
            }
        })().catch()
    }, [])

    return {data : settings, loading : loading, error : error};
}

export default useSettingsApi;